// koreaLanguage.ts
// ─── Astria Korea — EN/KO language ─────────────────────────────────────────
// Follows the user's preferred language (utils/appLanguage.ts): Korean when
// that is the preference, English otherwise. Replaces the old region-based
// detection, so a Korea-region user who prefers English gets English.
import { getAppLanguage, pickLanguage, useAppLanguage } from "../../utils/appLanguage";

export type KoreaLang = "en" | "ko";

const SUPPORTED: readonly KoreaLang[] = ["en", "ko"];

const resolve = (appLanguage: string): KoreaLang =>
  pickLanguage(appLanguage, SUPPORTED);

export const getKoreaLang = (): KoreaLang => resolve(getAppLanguage());

export function useKoreaLanguage(): KoreaLang {
  return resolve(useAppLanguage());
}
